<template>
  

<div>

 <b-modal  id="barcodemodal" :title="nom_article"  hide-footer>


 <div class="row d-flex justify-content-center">

                        <!-- Earnings (Monthly) Card Example -->
                        <div  class="pb-3">
                        <div class="card border-left-primary">




                                <div class="d-flex justify-content-center">
                                <div ref="barCode">
                                    <vue-barcode
                                        
                                        v-bind:value="code_barre"
                                        ref="BarImg"
                                        tag="img"
                                       

                                    />
                                </div>

                                </div>
                        </div>
                        </div>

</div>

              <div class="row">



           <div class="col">
            <form @submit.prevent="handleSubmitLot()"> 

            <div class="row">
          
                        <div class="form-group col">

                          <label for="Taille">Taille :</label>
                            <select class="form-control" id="Taille" v-model="taille">
                            <option></option>
                            <option>  XS </option>
                            <option>  S </option>
                            <option>  M </option>
                            <option>  L </option>
                            <option>  XL </option>
                            <option>  XXL </option>
                            <option>  XXXL </option>
                            <option>  XXXXL </option>
                            </select>

                        </div>


  




                        <div class="form-group col">
                            <label for="Prix">Prix :</label>
                            <input type="text" v-model="prix" id="Prix" name="Prix" class="form-control"
                                :class="{ 'is-invalid': isSubmitted && $v.prix.$error }" />
                            <div v-if="isSubmitted && !$v.prix.required" class="invalid-feedback">Ce champ est obligatoire !!</div>
                            <div v-if="isSubmitted && !$v.prix.decimal" class="invalid-feedback">Entrez une valeur numérique !!</div>
                        </div>
            </div>



            <div class="row">
                


                <div class="form-group col">
                <div class="custom-control custom-switch">
                <input type="checkbox"
                 class="custom-control-input" 
                 id="is_solde"
                        v-model="is_solde"
                        name="is_solde"
                        value=true
                        unchecked-value=false
    
                 >
    
                <label class="custom-control-label" for="is_solde">Avec Solde :</label>
                </div>
                </div>
    
                <div v-if="is_solde" class="form-group col">
                    <label for="solde">Solde :</label>
                    <input type="text" v-model="solde" id="solde" name="solde" class="form-control"
                                :class="{ 'is-invalid': isSubmitted && $v.solde.$error }" />
                            <div v-if="isSubmitted && !$v.solde.required" class="invalid-feedback">Ce champ est obligatoire !!</div>
                            <div v-if="isSubmitted && !$v.solde.decimal" class="invalid-feedback">Entrez une valeur numérique !!</div>
                </div>
            </div>
            
            <div class="row">

                        <div class="form-group col">
                            <label for="nmrbrTicket">Nombre De Ticket :</label>
                            <input type="text" v-model="nmrbrTicket" id="nmrbrTicket" name="nmrbrTicket" class="form-control"
                                :class="{ 'is-invalid': isSubmitted && $v.nmrbrTicket.$error }" />
                            <div v-if="isSubmitted && !$v.nmrbrTicket.required" class="invalid-feedback">Ce champ est obligatoire !!</div>
                            <div v-if="isSubmitted && !$v.nmrbrTicket.decimal" class="invalid-feedback">Entrez une valeur numérique !!</div>
                        </div>
            </div>




            <div class="form-group">
                <button type="submit" class="btn  btn-secondary btn-block">Générer</button>
            </div>

        </form>

                        </div>
              </div>





</b-modal>


    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true" color="#0179F9" loader='bars'></loading>
</div>

</template>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import {required,decimal} from "vuelidate/lib/validators";
import VueBarcode from 'vue-barcode';
import html2canvas from "html2canvas"; 
import jsPDF from 'jspdf';

export default {
 props: ['nom_article','code_barre','prix','is_solde','solde'],

      computed: {


      total_price: function() {
      return this.LotsList.reduce((a, b) => +a + +b.qte, 0);
    }
  },
	data () {
		return {
            
            taille: '',

            nmrbrTicket: 1,

            isSubmitted: false,
            isLoading: false,

            isLotGst: false
		}
	},
    validations: {
            nmrbrTicket: {
                    required,
                    decimal
            },
            prix: {
                    required,
                    decimal
            },
            solde: {
                    required,
                    decimal
            }

    },
    methods :{

        handleSubmitLot() {

                this.isSubmitted = true;

                this.$v.$touch();
                if (this.$v.$invalid) {
                this.flashMessage.show({
                status: 'info',
                title: 'Vérifiez les données et Reésayez !!',
                })
                }
                else 
                {

                    if(this.is_solde==1)
                    {
                    this.print_Sode_pdf();
                    }
                    else
                    {
                      this.print_pdf();
                    }

                }
        },


        print_pdf()
        {
            const doc = new jsPDF(
                {
                orientation: "landscape",
                unit: "mm",
                format: [70, 50]
                }
            );

            if(this.nmrbrTicket>0)
            {


                        html2canvas(this.$refs.barCode).then((canvas) => {
                           const img = canvas.toDataURL("image/png");

                            for (let i = 0; i < this.nmrbrTicket; i++) {

                                doc.setFontSize(17);
                                doc.text("ACM MAGIC", 35, 7,{ align: 'center' });
                                doc.setFontSize(14);
                                doc.text("Prix : "+this.prix+" DH", 35, 14,{ align: 'center' });

                                doc.setFontSize(11);
                                    doc.text(this.nom_article, 35, 19,{ align: 'center' });
                                    if(this.taille)
                                    {
                                    doc.text(this.taille, 35, 23,{ align: 'center' });
                                    }
                                doc.addImage(img, "PNG", 5, 24, 60, 22);   
                                
               

                                
                                doc.addPage();
                            }
                            
                            doc.save("Code_Barre_"+this.nom_article+".pdf");
                        })


            }
            else
            {
                            this.flashMessage.show({
                            status: 'info',
                            title: 'Vérifiez le nombre de tickets !!',
                            })
            }


        },




        print_Sode_pdf()
        {
            const doc = new jsPDF(
                {
                orientation: "landscape",
                unit: "mm",
                format: [70, 50]
                }
            );

            if(this.nmrbrTicket>0)
            {


                        html2canvas(this.$refs.barCode).then((canvas) => {
                           const img = canvas.toDataURL("image/png");

                            for (let i = 0; i < this.nmrbrTicket; i++) {

                                doc.setFontSize(17);
                                doc.text("ACM MAGIC", 35, 7,{ align: 'center' });
                                doc.setFontSize(13);
                                doc.text("Prix : "+this.prix+" DH", 35, 13,{ align: 'center' });
                                doc.line(17, 11.5, 53, 11.5);
                                doc.setFontSize(14);
                                doc.text("Sode : "+this.solde+" DH", 35, 19,{ align: 'center' });

                                doc.setFontSize(11);
                                    doc.text(this.nom_article, 35, 24,{ align: 'center' });
                                    if(this.taille)
                                    {
                                    doc.text(this.taille, 35, 27,{ align: 'center' });
                                    }
                                doc.addImage(img, "PNG", 5, 28, 60, 22);   
                                
                                doc.addPage();
                            }
                            
                            doc.save("Code_Barre_"+this.nom_article+".pdf");
                        })


            }
            else
            {
                            this.flashMessage.show({
                            status: 'info',
                            title: 'Vérifiez le nombre de tickets !!',
                            })
            }



        }


        
    }

    ,
    components: {
              Loading,

              "vue-barcode": VueBarcode,
             
    }
}
</script>

<style>

</style>